import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};
export const getOrders = (token, params) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/exports`, {
  params,
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
